import { configureStore, createSlice } from '@reduxjs/toolkit';

// Define the initial state for the theme
const initialThemeState = {
  mode: typeof window !== 'undefined' ? localStorage.getItem('theme') || 'light' : 'light',
};

// Create a slice for the theme
const themeSlice = createSlice({
  name: 'theme',
  initialState: initialThemeState,
  reducers: {
    setTheme: (state, action) => {
      state.mode = action.payload === 'system' ? window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light' : action.payload;
      if (typeof window !== 'undefined') {
        if(action.payload === 'light') {
          document.documentElement.classList.remove('dark');
          document.documentElement.classList.add('light');
          localStorage.setItem('theme', action.payload);
        }
    
        if(action.payload === 'dark') {
          document.documentElement.classList.remove('light');
          document.documentElement.classList.add('dark');
          localStorage.setItem('theme', action.payload);
        }
    
        if(action.payload === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches) {
          document.documentElement.classList.remove('light');
          document.documentElement.classList.add('dark');
          localStorage.removeItem('theme')
        }
    
        if(action.payload === 'system' && window.matchMedia('(prefers-color-scheme: light)').matches) {
          document.documentElement.classList.remove('dark');
          document.documentElement.classList.add('light');
          localStorage.removeItem('theme')
        }
      }
    },
  },
});

// Export the actions generated by createSlice
export const { setTheme } = themeSlice.actions;

// Create the store
const createStore = () => {
  return configureStore({
    reducer: {
      theme: themeSlice.reducer,
    },
  });
};

export default createStore;